import { setEqualHeight } from './equalHeight.js';
setEqualHeight( '.e-stn--awards-carousel', '.e-crd > p' );

document.addEventListener( 'DOMContentLoaded', () => {
  const nextButton = document.querySelector( '.e-stn--awards-carousel .swiper-button-next' );
  const prevButton = document.querySelector( '.e-stn--awards-carousel .swiper-button-prev' );

  if ( nextButton && prevButton ) {
    const buttonWrapper = document.createElement( 'div' );
    buttonWrapper.classList.add( 'swiper-btn-wrapper' );
    buttonWrapper.appendChild( nextButton );
    buttonWrapper.appendChild( prevButton );

    const rightContentBlock = document.querySelector( '.e-stn--awards-carousel .e-div--right-content' );
    if ( rightContentBlock ) {
      rightContentBlock.appendChild( buttonWrapper );
    }
  }
} );
